import {
  getAllStatByWeek,
  getStatEsta,
  getAppDeviceVersion,
  getSuiviClient,
  getStatForEstablishmentParticipationActivities
} from '../api/export'

const FileDownload = require('js-file-download');

export async function expAllStatByWeek(filename){
  const result = await getAllStatByWeek();
  if (result) FileDownload(result, `${filename}.xlsx`);
}

export async function expStatEsta(estaId, filename){
  const result = await getStatEsta(estaId);
  if (result) FileDownload(result, `${filename}.xlsx`);
}

export async function expAppDeviceVersion(filename) {
  const result = await getAppDeviceVersion();
  if (result) FileDownload(result, `${filename}.xlsx`);
}

export async function expSuiviClient(dStart, dEnd, filename) {
  const result =  await getSuiviClient(dStart, dEnd);
  if (result) FileDownload(result, `${filename}.xlsx`);
}

export async function statForEstablishmentParticipationActivities(estaId, start, end) {
  return getStatForEstablishmentParticipationActivities(estaId, start, end);
}